import {
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableHead
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import { CustomLineProgress } from "components/LineProgress";

import { BodyCell, BodyRow, HeadCell, TableContent } from "../../style";

export const StockTypeTable = ({
  storageStockTypesData,
  loading,
  handleOpenUpdate
}) => {
  return (
    <Box>
      {!!loading && <CustomLineProgress />}
      <TableContent component={Paper}>
        <Table stickyHeader>
          <TableHead>
            <HeadCell>ID</HeadCell>
            <HeadCell>Categoria</HeadCell>
            <HeadCell>Sigla</HeadCell>
            <HeadCell></HeadCell>
          </TableHead>
          <TableBody>
            {storageStockTypesData?.map(stockType => (
              <BodyRow key={stockType.id}>
                <BodyCell>{stockType.id}</BodyCell>
                <BodyCell>{stockType.name}</BodyCell>
                <BodyCell>{stockType.abbreviation?.toUpperCase()}</BodyCell>
                <BodyCell>
                  <IconButton onClick={() => handleOpenUpdate(stockType.id)}>
                    <EditIcon />
                  </IconButton>
                </BodyCell>
              </BodyRow>
            ))}
          </TableBody>
        </Table>
      </TableContent>
    </Box>
  );
};
